import React from "react";
import PropTypes from "prop-types";

const ArrivalModal = ({ open, onYes, onNo }) => {
  if (!open) {
    return null;
  }

  return (
    <div className="arrival-modal">
      <div className="arrival-modal-overlay">
        <div className="arrival-modal-content">
          <h3 className="arrival-modal-title">Arrivée chez le client?</h3>
          <div className="arrival-modal-actions">
            <button
              className="arrival-modal-button arrival-modal-button--yes"
              onClick={onYes}
            >
              OUI
            </button>
            <button
              className="arrival-modal-button arrival-modal-button--no"
              onClick={onNo}
            >
              NON
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ArrivalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
};

export default ArrivalModal;
